export const MEDIA_QUERY = {
  // Min width
  DESKTOP: "1280px",
  TABLET: "450px",
  // Max Width
  MOBILE: "450px",
};
